import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VCard,[_c(VCardText,[_c('h1',{staticStyle:{"text-align":"center","width":"100%"}},[_vm._v(_vm._s(_vm.titulo))])]),_c(VCardActions,{staticClass:"justify-space-around pa-3"},[_c(VBtn,{attrs:{"round":""},on:{"click":function($event){return _vm.$emit('nao')}}},[_vm._v("Não")]),_c(VBtn,{attrs:{"round":"","color":"error"},on:{"click":function($event){return _vm.$emit('sim')}}},[_vm._v("Sim")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }